<template>
  <div class="page-content ai-tools">
    <AiPrompts />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import util from '@/Utils/util';

const AiPrompts = defineAsyncComponent(() => import('./AiTools/AiPrompts.vue') as any);

util.moveToTop();
</script>
